import * as angular from "angular";
import { NationBuilderDataProvider } from "../../data-provider/nation-builder.dp";
import { DialogUtils } from "../../helper/dialog.helper";
import { SurveyDataProvider } from "../../data-provider/survey.dp";
import { PermissionCheck } from "../../shared/permission";

let SurveyLists = {
    selector: "vcSurveyLists",
    templateUrl: "/angular/components/survey/survey-lists.component.html",
    bindings: {},
    controller: class SurveyListsController {
        public isLeaderView: boolean;
        public loading = true;
        public nation: any;
        public showNationbuilderButton = false;
        public loadingNations = false;
        public surveys: any;
        public timeoutCode: any;
        public delayInMs: number;
        public savingSurveys = false;

        private $scope: any;
        private dialog: DialogUtils;
        private $timeout: any;
        private $window: any;
        private dataProvider: SurveyDataProvider;
        public permissionProvider: PermissionCheck;

        constructor(
            $scope: any,
            DialogUtils: DialogUtils,
            $timeout: any,
            $window: any,
            __app_type: string,
            SurveyDataProvider: SurveyDataProvider,
            NationBuilderDataProvider: NationBuilderDataProvider,
            PermissionCheck: PermissionCheck
        ) {
            this.$scope = $scope;
            this.dialog = DialogUtils;
            this.$timeout = $timeout;
            this.$window = $window;
            this.dataProvider = SurveyDataProvider;
            this.permissionProvider = PermissionCheck;

            this.isLeaderView = __app_type == "LEADER";

            if (!this.isLeaderView) {
                this.loadingNations = true;
                NationBuilderDataProvider.getNations().then(
                    (jsonData: any) => {
                        if (jsonData.length > 0) {
                            this.nation = jsonData[0];
                            if (this.nation.nbaccesstoken) {
                                this.showNationbuilderButton = true;
                            }
                        }
                        this.loadingNations = false;
                    },
                    () => (this.loadingNations = false)
                );
            }

            this.dataProvider.getSurveyLists().then((surveys: any[]) => {
                this.surveys = surveys;
                this.loading = false;
            });

            this.$scope.$watch(
                () => this.surveys,
                (newValue: any[], oldValue: any[]) => {
                    if (newValue && oldValue && newValue !== oldValue) {
                        this.saveSurveys();
                    }
                },
                true
            );

            this.delayInMs = this.isLeaderView ? 2000 : 1000;
        }

        saveSurveys(): void {
            this.$timeout.cancel(this.timeoutCode); //does nothing, if timeout already done
            this.timeoutCode = this.$timeout(() => {
                if (!this.savingSurveys) {
                    this.savingSurveys = true;

                    let data = {
                        live: this.surveyIds("live"),
                        notlive: this.surveyIds("notlive"),
                    };

                    if (this.surveys.liveDisabled.length) {
                        data.live = this.surveyIds("liveDisabled").concat(
                            data.live
                        );
                    }

                    this.dataProvider.updateOrder(data).then(
                        () => (this.savingSurveys = false),
                        () => (this.savingSurveys = false)
                    );
                }
            }, this.delayInMs);
        }

        updateSurvey(survey: any, ev: any): void {
            this.dialog
                .show({
                    component: "vc-survey-form",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {
                        selectedSurvey: survey,
                        teamOnly: true,
                    },
                })
                .then((updatedSurvey: any) => {
                    survey.team = null;
                    angular.extend(survey, updatedSurvey);
                });
        }

        createSurveyDialog(ev: any): void {
            this.dialog
                .show({
                    component: "vc-survey-form",
                    targetEvent: ev,
                    scope: this.$scope,
                    locals: {
                        selectedSurvey: {},
                        teamOnly: false,
                    },
                })
                .then((survey: any) => {
                    this.dataProvider.clearAll();
                    this.goToSurvey(survey);
                });
        }

        goToSurvey(survey: any): void {
            if (this.isLeaderView) {
                this.$window.location =
                    "./leader.php#/leader_survey/" + survey.sid;
            } else {
                this.$window.location = "./#/survey/" + survey.sid;
            }
        }

        openErrorDialog(string: string, ev?: any): void {
            const content =
                string == "publish"
                    ? "Sorry but you need at least 1 question to publish a survey!"
                    : "This survey was published at organization level so cannot be altered at the account level!";

            let dialog = this.dialog
                .alert()
                .textContent(content)
                .targetEvent(ev)
                .ok("OK");
            this.dialog.showPreConfiguredDialog(dialog);
        }

        onDrop(item: any): any {
            if (item.question_count <= 0 && !item.osid) {
                this.openErrorDialog("publish");
                return false;
            } else if (item.osid) {
                this.openErrorDialog("leader");
                return false;
            } else {
                return item;
            }
        }

        surveyIds(type: string): number[] {
            if (this.surveys[type].length) {
                return this.surveys[type].map((item: any) => {
                    return item["sid"];
                });
            }
            return [];
        }
    },
};

angular.module("survey").component(SurveyLists.selector, SurveyLists);
